export const SUPPLEMENT_SECTIONS = {
  22: {
    supplements: [
      {
        id: 3980,
        name: 'Укладка мозаики',
        price: 4600,
        unit: 'METER_SQUARED',
      },
      {
        id: 3977,
        name: 'Диагональная укладка керамогранита (120*60 см)',
        price: 3500,
        unit: 'METER_SQUARED',
      },
      {
        id: 3974,
        name: 'Прямая укладка керамогранита (120*60 см)',
        price: 3300,
        unit: 'METER_SQUARED',
      },
      {
        id: 5449,
        name: 'Укладка плитки из натурального камня',
        price: 3300,
        unit: 'METER_SQUARED',
      },
      {
        id: 3971,
        name: 'Диагональная укладка керамогранита (60*60 см)',
        price: 3000,
        unit: 'METER_SQUARED',
      },
      {
        id: 3968,
        name: 'Прямая укладка керамогранита (60*60 см)',
        price: 2800,
        unit: 'METER_SQUARED',
      },
      {
        id: 3965,
        name: 'Диагональная укладка керамогранита (менее 60*60 см)',
        price: 2500,
        unit: 'METER_SQUARED',
      },
      {
        id: 3962,
        name: 'Прямая укладка керамогранита (менее 60*60 см)',
        price: 2300,
        unit: 'METER_SQUARED',
      },
      {
        id: 3959,
        name: 'Диагональная укладка керамической плитки',
        price: 2300,
        unit: 'METER_SQUARED',
      },
      {
        id: 3992,
        name: 'Укладка клинкерной интерьерной плитки',
        price: 2400,
        unit: 'METER_SQUARED',
      },
      {
        id: 3989,
        name: 'Прямая укладка плитки «кабанчик»',
        price: 2900,
        unit: 'METER_SQUARED',
      },
      {
        id: 3956,
        name: 'Прямая укладка керамической плитки',
        price: 2100,
        unit: 'METER_SQUARED',
      },
      {
        id: 177,
        name: 'Демонтаж плитки со стен/пола с сохранением',
        price: 500,
        unit: 'METER_SQUARED',
      },
      {
        id: 2571,
        name: 'Демонтаж плитки со стен без сохранения',
        price: 300,
        unit: 'METER_SQUARED',
      },
      {
        id: 2572,
        name: 'Демонтаж плитки с пола без сохранения',
        price: 300,
        unit: 'METER_SQUARED',
      },
    ],
    id: 22,
    name: 'Плитка',
  },
  29: {
    supplements: [
      {
        id: 4165,
        name: 'Прямая укладка паркетной доски на обрешетку потолка саморезами',
        price: 1380,
        unit: 'METER_SQUARED',
      },
      {
        id: 4162,
        name: 'Прямая укладка паркетной доски на обрешетку стены саморезами',
        price: 1100,
        unit: 'METER_SQUARED',
      },
      {
        id: 1622,
        name: 'Замер перед обшивкой стен',
        price: 1100,
        unit: 'VISIT',
      },
      {
        id: 4156,
        name: 'Укладка на клей плитки ПВХ на потолок',
        price: 1050,
        unit: 'METER_SQUARED',
      },
      {
        id: 4150,
        name: 'Укладка замковой плитки ПВХ  на потолок',
        price: 1050,
        unit: 'METER_SQUARED',
      },
      {
        id: 4144,
        name: 'Прямая укладка ламината на обрешетку потолока саморезами',
        price: 1050,
        unit: 'METER_SQUARED',
      },
      {
        id: 4159,
        name: 'Прямая укладка на стены паркетной доски на клей',
        price: 1000,
        unit: 'METER_SQUARED',
      },
      {
        id: 4147,
        name: 'Укладка замковой плитки ПВХ  на стену',
        price: 850,
        unit: 'METER_SQUARED',
      },
      {
        id: 1341,
        name: 'Прямая укладка ламината на обрешетку стены саморезами',
        price: 1100,
        unit: 'METER_SQUARED',
      },
      {
        id: 4153,
        name: 'Укладка на клей плитки ПВХ на стену',
        price: 1100,
        unit: 'METER_SQUARED',
      },
      {
        id: 3109,
        name: 'Обшивка стен гипсокартоном в один слой (с заполнением)',
        price: 800,
        unit: 'METER_SQUARED',
      },
      {
        id: 930,
        name: 'Облицовка потолка гипсокартоном',
        price: 800,
        unit: 'METER_SQUARED',
      },
      {
        id: 2546,
        name: 'Монтаж панелей ПВХ/МДФ на потолок на жидкие гвозди',
        price: 1000,
        unit: 'METER_SQUARED',
      },
      {
        id: 2552,
        name: 'Монтаж листовых панелей ПВХ на потолок на жидкие гвозди',
        price: 550,
        unit: 'METER_SQUARED',
      },
      {
        id: 2554,
        name: 'Монтаж виниловых панелей на потолок на обрешетку',
        price: 550,
        unit: 'METER_SQUARED',
      },
      {
        id: 2556,
        name: 'Монтаж ЛХДФ панелей на потолок на жидкие гвозди',
        price: 550,
        unit: 'METER_SQUARED',
      },
      {
        id: 228,
        name: 'Обшивка стен панелями из ПВХ, ДСП, ДВП, ОCБ, фанерой',
        price: 600,
        unit: 'METER_SQUARED',
      },
      {
        id: 227,
        name: 'Обшивка стен гипсокартоном в один слой (без заполнения)',
        price: 600,
        unit: 'METER_SQUARED',
      },
      {
        id: 229,
        name: 'Обшивка стен вагонкой',
        price: 600,
        unit: 'METER_SQUARED',
      },
      {
        id: 2545,
        name: 'Монтаж панелей ПВХ/МДФ на стены на жидкие гвозди',
        price: 900,
        unit: 'METER_SQUARED',
      },
      {
        id: 2551,
        name: 'Монтаж листовых панелей ПВХ на стены на жидкие гвозди',
        price: 500,
        unit: 'METER_SQUARED',
      },
      {
        id: 2553,
        name: 'Монтаж виниловых панелей на стену на обрешетку',
        price: 500,
        unit: 'METER_SQUARED',
      },
      {
        id: 2555,
        name: 'Монтаж ЛХДФ панелей на стены на жидкие гвозди',
        price: 500,
        unit: 'METER_SQUARED',
      },
      {
        id: 2548,
        name: 'Монтаж панелей ПВХ/МДФ на потолок на обрешетку',
        price: 600,
        unit: 'METER_SQUARED',
      },
      {
        id: 2558,
        name: 'Монтаж ЛХДФ панелей на потолок на обрешётку',
        price: 450,
        unit: 'METER_SQUARED',
      },
      {
        id: 2547,
        name: 'Монтаж панелей ПВХ/МДФ на стену на обрешетку',
        price: 700,
        unit: 'METER_SQUARED',
      },
      {
        id: 2557,
        name: 'Монтаж ЛХДФ панелей на стены на обрешётку',
        price: 400,
        unit: 'METER_SQUARED',
      },
      {
        id: 939,
        name: 'Облицовка потолка пробкой',
        price: 200,
        unit: 'METER_SQUARED',
      },
      {
        id: 937,
        name: 'Облицовка потолка пенопластом',
        price: 200,
        unit: 'METER_SQUARED',
      },
      {
        id: 233,
        name: 'Монтаж дополнительного слоя гипсокартона',
        price: 200,
        unit: 'METER_SQUARED',
      },
      {
        id: 241,
        name: 'Демонтаж обшивки стен',
        price: 300,
        unit: 'METER_SQUARED',
      },
      {
        id: 239,
        name: 'Обработка деревянной вагонки огне- или биозащитой, лаком',
        price: 150,
        unit: 'METER_SQUARED',
      },
      {
        id: 234,
        name: 'Монтаж тепло- и шумоизоляции в один слой',
        price: 200,
        unit: 'METER_SQUARED',
      },
    ],
    id: 29,
    name: 'Отделка, обшивка, облицовка',
  },
  51: {
    supplements: [
      {
        id: 1099,
        name: 'Покраска радиатора отопления',
        price: 1000,
        unit: 'PIECE',
      },
      {
        id: 1312,
        name: 'Покраска ванны 170 см',
        price: 700,
        unit: 'PIECE',
      },
      {
        id: 512,
        name: 'Покраска потолка масляной краской',
        price: 500,
        unit: 'METER_SQUARED',
      },
      {
        id: 793,
        name: 'Покраска пола',
        price: 500,
        unit: 'METER_SQUARED',
      },
      {
        id: 1311,
        name: 'Покраска ванны 150 см',
        price: 500,
        unit: 'PIECE',
      },
      {
        id: 1065,
        name: 'Покраска потолка эмалью / воднодисперсионной / акриловой краской',
        price: 600,
        unit: 'METER_SQUARED',
      },
      {
        id: 511,
        name: 'Покраска потолка водоэмульсионной краской',
        price: 450,
        unit: 'METER_SQUARED',
      },
      {
        id: 510,
        name: 'Покраска внутренних стен масляной краской',
        price: 400,
        unit: 'METER_SQUARED',
      },
      {
        id: 1221,
        name: 'Покраска обоев в 2 слоя',
        price: 350,
        unit: 'METER_SQUARED',
      },
      {
        id: 2025,
        name: 'Покраска внутренних стен эмалью или водно-дисперсионной краской',
        price: 350,
        unit: 'METER_SQUARED',
      },
      {
        id: 509,
        name: 'Покраска внутренних стен водоэмульсионной краской',
        price: 350,
        unit: 'METER_SQUARED',
      },
      {
        id: 1063,
        name: 'Дополнительный слой покраски потолка масляной краской',
        price: 250,
        unit: 'METER_SQUARED',
      },
      {
        id: 1090,
        name: 'Дополнительный слой покраски пола',
        price: 250,
        unit: 'METER_SQUARED',
      },
      {
        id: 1064,
        name: 'Дополнительный слой покраски потолка эмалью',
        price: 225,
        unit: 'METER_SQUARED',
      },
      {
        id: 1062,
        name: 'Дополнительный слой покраски потолка водоэмульсионной краской',
        price: 225,
        unit: 'METER_SQUARED',
      },
      {
        id: 948,
        name: 'Покраска потолочного плинтуса в 2 слоя',
        price: 200,
        unit: 'METER',
      },
      {
        id: 1056,
        name: 'Дополнительный слой покраски стен масляной краской',
        price: 200,
        unit: 'METER_SQUARED',
      },
      {
        id: 513,
        name: 'Покраска наружных стен',
        price: 180,
        unit: 'METER_SQUARED',
      },
      {
        id: 2045,
        name: 'Дополнительный слой покраски стен эмалью/водно-дисперсионной краской',
        price: 175,
        unit: 'METER_SQUARED',
      },
      {
        id: 1054,
        name: 'Дополнительный слой покраски стен водоэмульсионной краской',
        price: 300,
        unit: 'METER_SQUARED',
      },
      {
        id: 4416,
        name: 'Покраска плинтуса',
        price: 150,
        unit: 'METER',
      },
    ],
    id: 51,
    name: 'Покраска',
  },
  54: {
    supplements: [
      {
        id: 725,
        name: 'Установка силовой розетки под прибор бытовой техники',
        price: 600,
        unit: 'PIECE',
      },
      {
        id: 530,
        name: 'Демонтаж сушильной машины',
        price: 600,
        unit: 'PIECE',
      },
      {
        id: 684,
        name: 'Демонтаж стиральной машины',
        price: 600,
        unit: 'PIECE',
      },
    ],
    id: 54,
    name: 'Бытовая техника',
  },
  68: {
    supplements: [
      {
        id: 631,
        name: 'Подвод электричества к точке с прокладкой провода до 3 метров',
        price: 2000,
        unit: 'PIECE',
      },
      {
        id: 633,
        name: 'Установка встроенного щитка (6-12 модулей)',
        price: 2000,
        unit: 'PIECE',
      },
      {
        id: 632,
        name: 'Монтаж скрытой проводки',
        price: 1200,
        unit: 'METER',
      },
      {
        id: 1151,
        name: 'Установка четырёхполюсного УЗО или дифференциального автомата',
        price: 1000,
        unit: 'PIECE',
      },
      {
        id: 635,
        name: 'Установка накладного щитка',
        price: 700,
        unit: 'PIECE',
      },
      {
        id: 1149,
        name: 'Установка трёхполюсного автомата',
        price: 600,
        unit: 'PIECE',
      },
      {
        id: 640,
        name: 'Подключение кабеля к линии в щите',
        price: 600,
        unit: 'PIECE',
      },
      {
        id: 639,
        name: 'Подвод электричества к точке с прокладкой провода свыше 3 метров',
        price: 600,
        unit: 'METER',
      },
      {
        id: 634,
        name: 'Составление плана электропроводки',
        price: 600,
        unit: 'PIECE',
      },
      {
        id: 1148,
        name: 'Установка двухполюсного автомата',
        price: 500,
        unit: 'PIECE',
      },
      {
        id: 1150,
        name: 'Установка двухполюсного УЗО или дифференциального автомата',
        price: 500,
        unit: 'PIECE',
      },
      {
        id: 1147,
        name: 'Установка однополюсного автомата',
        price: 400,
        unit: 'PIECE',
      },
      {
        id: 5460,
        name: 'Монтаж металлического лотка для кабеля',
        price: 400,
        unit: 'METER',
      },
      {
        id: 641,
        name: 'Монтаж внутренней распаячной коробки',
        price: 300,
        unit: 'PIECE',
      },
      {
        id: 1339,
        name: 'Демонтаж трёхполюсного автомата',
        price: 400,
        unit: 'PIECE',
      },
      {
        id: 637,
        name: 'Монтаж накладной распаячной коробки',
        price: 300,
        unit: 'PIECE',
      },
      {
        id: 1338,
        name: 'Демонтаж двухполюсного автомата',
        price: 200,
        unit: 'PIECE',
      },
      {
        id: 630,
        name: 'Прокладка кабель-канала',
        price: 200,
        unit: 'METER',
      },
      {
        id: 627,
        name: 'Прокладка гофры',
        price: 200,
        unit: 'METER',
      },
      {
        id: 1337,
        name: 'Демонтаж однополюсного автомата',
        price: 200,
        unit: 'PIECE',
      },
      {
        id: 624,
        name: 'Демонтаж электропроводки',
        price: 100,
        unit: 'METER',
      },
    ],
    id: 68,
    name: 'Проводка, щитки',
  },
  81: {
    supplements: [
      {
        id: 740,
        name: 'Установка розетки для стиральной/посудомоечной машины (со штроблением)',
        price: 4500,
        unit: 'PIECE',
      },
      {
        id: 749,
        name: 'Установка розетки для стиральной/посудомоечной машины (провод в кабель-канале или по плинтусу)',
        price: 3600,
        unit: 'PIECE',
      },
      {
        id: 754,
        name: 'Установка силовой розетки под прибор бытовой техники',
        price: 3000,
        unit: 'PIECE',
      },
      {
        id: 746,
        name: 'Установка блока из двух розеток (с подведением электричества)',
        price: 3000,
        unit: 'PIECE',
      },
      {
        id: 1265,
        name: 'Установка дополнительной розетки с подведением коммуникаций',
        price: 2400,
        unit: 'PIECE',
      },
      {
        id: 752,
        name: 'Перенос розетки',
        price: 2400,
        unit: 'PIECE',
      },
      {
        id: 748,
        name: 'Установка второй, третьей, четвёртой и т.д. дополнительной розетки (с подведением электричества)',
        price: 1200,
        unit: 'PIECE',
      },
      {
        id: 755,
        name: 'Установка дополнительной розетки в блок с подведением коммуникаций (после 2-ух розеток в блоке)',
        price: 600,
        unit: 'PIECE',
      },
      {
        id: 750,
        name: 'Установка розетки (на готовые коммуникации)',
        price: 500,
        unit: 'PIECE',
      },
      {
        id: 1256,
        name: 'Установка выключателя (на готовые коммуникации)',
        price: 500,
        unit: 'PIECE',
      },
      {
        id: 751,
        name: 'Замена розетки',
        price: 500,
        unit: 'PIECE',
      },
      {
        id: 753,
        name: 'Замена одинарной розетки на двойную',
        price: 500,
        unit: 'PIECE',
      },
      {
        id: 744,
        name: 'Замена выключателя',
        price: 500,
        unit: 'PIECE',
      },
      {
        id: 1257,
        name: 'Демонтаж выключателя',
        price: 300,
        unit: 'PIECE',
      },
    ],
    id: 81,
    name: 'Розетки, выключатели',
  },
  83: {
    supplements: [
      {
        id: 773,
        name: 'Демонтаж реечного потолка',
        price: 600,
        unit: 'METER_SQUARED',
      },
      {
        id: 779,
        name: 'Демонтаж подвесного потолка',
        price: 600,
        unit: 'METER_SQUARED',
      },
      {
        id: 2415,
        name: 'Демонтаж потолка из гипсокартона',
        price: 500,
        unit: 'METER_SQUARED',
      },
      {
        id: 3836,
        name: 'Демонтаж потолка грильято',
        price: 350,
        unit: 'METER_SQUARED',
      },
      {
        id: 1279,
        name: 'Демонтаж натяжного потолка',
        price: 300,
        unit: 'METER_SQUARED',
      },
      {
        id: 776,
        name: 'Разборка конструкции потолка',
        price: 150,
        unit: 'METER_SQUARED',
      },
      {
        id: 774,
        name: 'Демонтаж освещения',
        price: 200,
        unit: 'PIECE',
      },
      {
        id: 777,
        name: 'Демонтаж короба из гипсокартона на потолке',
        price: 200,
        unit: 'METER_SQUARED',
      },
      {
        id: 775,
        name: 'Демонтаж потолочной плитки из полистирола',
        price: 200,
        unit: 'METER_SQUARED',
      },
      {
        id: 778,
        name: 'Демонтаж потолочного плинтуса',
        price: 60,
        unit: 'METER',
      },
    ],
    id: 83,
    name: 'Демонтаж потолка',
  },
  90: {
    supplements: [
      {
        id: 847,
        name: 'Сборка и навеска люстры',
        price: 1800,
        unit: 'PIECE',
      },
      {
        id: 848,
        name: 'Сборка и навеска бра',
        price: 1800,
        unit: 'PIECE',
      },
      {
        id: 850,
        name: 'Навеска тяжёлой люстры',
        price: 1800,
        unit: 'PIECE',
      },
      {
        id: 1226,
        name: 'Установка блока питания, контроллера',
        price: 1500,
        unit: 'PIECE',
      },
      {
        id: 1225,
        name: 'Установка Трековой системы',
        price: 1400,
        unit: 'METER',
      },
      {
        id: 845,
        name: 'Сборка сложной люстры',
        price: 1200,
        unit: 'PIECE',
      },
      {
        id: 1227,
        name: 'Установка Спота',
        price: 1100,
        unit: 'PIECE',
      },
      {
        id: 1159,
        name: 'Установка кронштейна для люстры в натяжной потолок',
        price: 1000,
        unit: 'PIECE',
      },
      {
        id: 1228,
        name: 'Установка диммера',
        price: 600,
        unit: 'PIECE',
      },
      {
        id: 849,
        name: 'Навеска подвесок на люстру',
        price: 600,
        unit: 'PIECE',
      },
      {
        id: 851,
        name: 'Навеска люстры на декоративный/гипсокартонный/ натяжной потолок',
        price: 600,
        unit: 'PIECE',
      },
      {
        id: 1160,
        name: 'Монтаж светодиодной ленты на подвесной/натяжной потолок',
        price: 500,
        unit: 'METER',
      },
      {
        id: 1230,
        name: 'Модификация светильника под двухклавишный выключатель',
        price: 600,
        unit: 'PIECE',
      },
      {
        id: 1229,
        name: 'Установка выключателя на светильник',
        price: 450,
        unit: 'PIECE',
      },
      {
        id: 3056,
        name: 'Установка фотореле',
        price: 400,
        unit: 'PIECE',
      },
      {
        id: 843,
        name: 'Установка точечного светильника',
        price: 500,
        unit: 'PIECE',
      },
      {
        id: 1161,
        name: 'Монтаж точечного светильника на подвесной/натяжной потолок',
        price: 500,
        unit: 'PIECE',
      },
      {
        id: 1083,
        name: 'Монтаж светодиодной ленты',
        price: 500,
        unit: 'METER',
      },
      {
        id: 846,
        name: 'Установка крюка для люстры',
        price: 400,
        unit: 'PIECE',
      },
      {
        id: 1231,
        name: 'Демонтаж старого светильника',
        price: 400,
        unit: 'PIECE',
      },
    ],
    id: 90,
    name: 'Освещение',
  },
  101: {
    supplements: [
      {
        id: 1016,
        name: 'Перенос стояка водоснабжения',
        price: 9600,
        unit: 'PIECE',
      },
      {
        id: 121,
        name: 'Подводка труб (ХВС, ГВС, канализация) к месту установки сантехнического оборудования (до 3 метров)',
        price: 5100,
        unit: 'PIECE',
      },
      {
        id: 122,
        name: 'Замена повреждённой трубы',
        price: 5100,
        unit: 'PIECE',
      },
      {
        id: 125,
        name: 'Выполнение перехода с чугунной трубы на пластиковую (расчеканка)',
        price: 3100,
        unit: 'PIECE',
      },
      {
        id: 5039,
        name: 'Удаление заглушки канализации',
        price: 3600,
        unit: 'PIECE',
      },
      {
        id: 128,
        name: 'Установка редуктора',
        price: 2600,
        unit: 'PIECE',
      },
      {
        id: 1012,
        name: 'Монтаж распределительной гребёнки',
        price: 2600,
        unit: 'PIECE',
      },
      {
        id: 1018,
        name: 'Монтаж вентиля на стояк',
        price: 2100,
        unit: 'PIECE',
      },
      {
        id: 1010,
        name: 'Врезка трубы в водопроводный стояк',
        price: 2600,
        unit: 'PIECE',
      },
      {
        id: 119,
        name: 'Установка байпаса',
        price: 1500,
        unit: 'PIECE',
      },
      {
        id: 1015,
        name: 'Разводка труб ХВС',
        price: 1800,
        unit: 'METER',
      },
      {
        id: 1017,
        name: 'Разводка труб ГВС',
        price: 1800,
        unit: 'METER',
      },
      {
        id: 1251,
        name: 'Разводка канализации',
        price: 1800,
        unit: 'METER',
      },
      {
        id: 606,
        name: 'Замена/поворот крестовины унитаза',
        price: 1500,
        unit: 'PIECE',
      },
      {
        id: 1346,
        name: 'Замена водозапорного крана',
        price: 1200,
        unit: 'PIECE',
      },
      {
        id: 1008,
        name: 'Монтаж вентиля',
        price: 900,
        unit: 'PIECE',
      },
      {
        id: 120,
        name: 'Подрезка трубы под размер радиатора',
        price: 600,
        unit: 'PIECE',
      },
      {
        id: 5324,
        name: 'Составление плана сантехники',
        price: 600,
        unit: 'PIECE',
      },
      {
        id: 1408,
        name: 'Нанесение резьбы на трубу',
        price: 450,
        unit: 'PIECE',
      },
      {
        id: 129,
        name: 'Сверление коронкой отверстия',
        price: 400,
        unit: 'PIECE',
      },
      {
        id: 1020,
        name: 'Штробление бетона',
        price: 230,
        unit: 'METER',
      },
      {
        id: 5040,
        name: 'Пайка полипропиленовых труб',
        price: 300,
        unit: 'POSITION',
      },
      {
        id: 1011,
        name: 'Штробление кирпича',
        price: 150,
        unit: 'METER',
      },
      {
        id: 1019,
        name: 'Штробление гипса',
        price: 130,
        unit: 'METER',
      },
      {
        id: 1306,
        name: 'Штробление газобетона',
        price: 130,
        unit: 'METER',
      },
    ],
    id: 101,
    name: 'Трубы и краны',
  },
  175: {
    supplements: [
      {
        id: 963,
        name: 'Установка терморегулятора',
        price: 1100,
        unit: 'PIECE',
      },
      {
        id: 970,
        name: 'Монтаж температурного датчика тёплого пола',
        price: 750,
        unit: 'PIECE',
      },
      {
        id: 855,
        name: 'Монтаж тёплого пола (водяного)',
        price: 600,
        unit: 'METER_SQUARED',
      },
      {
        id: 1264,
        name: 'Монтаж тёплого пола (электрического)',
        price: 500,
        unit: 'METER_SQUARED',
      },
    ],
    id: 175,
    name: 'Тёплый пол',
  },
  184: {
    supplements: [
      {
        id: 1275,
        name: 'Изготовление арки из ГКЛ (сложная конструкция, различные радиусы)',
        price: 5000,
        unit: 'PIECE',
      },
      {
        id: 1274,
        name: 'Изготовление арки из ГКЛ (простая конструкция, ровные радиусы)',
        price: 4800,
        unit: 'PIECE',
      },
      {
        id: 1272,
        name: 'Демонтаж стены из бетона (не несущей)',
        price: 2100,
        unit: 'METER_SQUARED',
      },
      {
        id: 1270,
        name: 'Возведение перегородки из кирпича',
        price: 1400,
        unit: 'METER_SQUARED',
      },
      {
        id: 232,
        name: 'Возведение перегородки из стеклоблоков',
        price: 1500,
        unit: 'METER_SQUARED',
      },
      {
        id: 231,
        name: 'Возведение перегородки из пазогребневых плит',
        price: 1300,
        unit: 'METER_SQUARED',
      },
      {
        id: 1268,
        name: 'Возведение перегородки из ГКЛ с наполнением',
        price: 1000,
        unit: 'METER_SQUARED',
      },
      {
        id: 801,
        name: 'Возведение перегородки из ГКЛ без наполнения',
        price: 650,
        unit: 'METER_SQUARED',
      },
      {
        id: 1278,
        name: 'Устройство ниши в стене из ГКЛ',
        price: 600,
        unit: 'METER',
      },
      {
        id: 1276,
        name: 'Изготовление короба из ГКЛ',
        price: 600,
        unit: 'METER',
      },
      {
        id: 1273,
        name: 'Демонтаж стены (не несущей) из кирпича/газоблока/ПГП',
        price: 600,
        unit: 'METER_SQUARED',
      },
      {
        id: 1086,
        name: 'Возведение перегородки из пеноблоков',
        price: 600,
        unit: 'METER_SQUARED',
      },
      {
        id: 3108,
        name: 'Демонтаж перегородок из ГКЛ',
        price: 400,
        unit: 'METER_SQUARED',
      },
      {
        id: 1277,
        name: 'Усиление конструкции вторым слоем ГКЛ',
        price: 200,
        unit: 'METER_SQUARED',
      },
      {
        id: 240,
        name: 'Установка плинтусов, наличников, раскладок, штапиков',
        price: 150,
        unit: 'PIECE',
      },
      {
        id: 197,
        name: 'Разборка конструкции потолка или стен',
        price: 150,
        unit: 'METER_SQUARED',
      },
      {
        id: 238,
        name: 'Монтаж усиленного металлического каркаса с шагом в 40 см',
        price: 200,
        unit: 'METER_SQUARED',
      },
      {
        id: 237,
        name: 'Установка закладных',
        price: 100,
        unit: 'PIECE',
      },
      {
        id: 235,
        name: 'Заделка стыков панелей гипсокартона армирующей лентой и шпатлевкой',
        price: 200,
        unit: 'METER',
      },
    ],
    id: 184,
    name: 'Возведение перегородок',
  },
  186: {
    supplements: [
      {
        id: 3834,
        name: 'Монтаж потолка грильято',
        price: 1500,
        unit: 'METER_SQUARED',
      },
      {
        id: 1280,
        name: 'Монтаж многоуровнего потолка из ГКЛ с заполнением',
        price: 1200,
        unit: 'METER_SQUARED',
      },
      {
        id: 269,
        name: 'Монтаж потолка Армстронг',
        price: 1050,
        unit: 'METER_SQUARED',
      },
      {
        id: 2414,
        name: 'Монтаж двухуровнего потолка из ГКЛ с заполнением',
        price: 1000,
        unit: 'METER_SQUARED',
      },
      {
        id: 268,
        name: 'Монтаж реечного потолка',
        price: 1000,
        unit: 'METER_SQUARED',
      },
      {
        id: 271,
        name: 'Монтаж подвесного потолка из гипсокартона (2 слоя)',
        price: 900,
        unit: 'METER_SQUARED',
      },
      {
        id: 1281,
        name: 'Монтаж одноуровнего потолка из ГКЛ с заполнением',
        price: 1000,
        unit: 'METER_SQUARED',
      },
      {
        id: 786,
        name: 'Монтаж зеркального потолка',
        price: 700,
        unit: 'METER_SQUARED',
      },
      {
        id: 270,
        name: 'Монтаж подвесного потолка из гипсокартона (1 слой)',
        price: 800,
        unit: 'METER_SQUARED',
      },
      {
        id: 1242,
        name: 'Монтаж потолочной люстры на кронштейне на подвесной потолок',
        price: 600,
        unit: 'PIECE',
      },
      {
        id: 5130,
        name: 'Вывод электрики и подключение осветительных приборов',
        price: 500,
        unit: 'METER',
      },
      {
        id: 1244,
        name: 'Монтаж точечного светильника на подвесной потолок',
        price: 600,
        unit: 'PIECE',
      },
      {
        id: 3835,
        name: 'Вставка светильников в  потолок грильято',
        price: 450,
        unit: 'PIECE',
      },
      {
        id: 1243,
        name: 'Монтаж светодиодной ленты на подвесной потолок',
        price: 350,
        unit: 'METER',
      },
      {
        id: 1241,
        name: 'Монтаж люстры на крючке на подвесной потолок',
        price: 350,
        unit: 'PIECE',
      },
      {
        id: 267,
        name: 'Монтаж кассетного потолка/потолочных плит',
        price: 500,
        unit: 'METER_SQUARED',
      },
      {
        id: 2416,
        name: 'Вырез отверстий в подвесном потолке (для пожарных сигнализаций, светильников, систем пожара тушений)',
        price: 500,
        unit: 'PIECE',
      },
      {
        id: 1282,
        name: 'Устройство закладных в ГКЛ для крепления штор, люстр, светильников и других электроприборов',
        price: 100,
        unit: 'PIECE',
      },
    ],
    id: 186,
    name: 'Монтаж подвесных потолков',
  },
  187: {
    supplements: [
      {
        id: 991,
        name: 'Монтаж лючка в натяжном потолке',
        price: 1200,
        unit: 'PIECE',
      },
      {
        id: 2384,
        name: 'Монтаж закладных для натяжного потолка',
        price: 1200,
        unit: 'PIECE',
      },
      {
        id: 989,
        name: 'Монтаж потолочной люстры на кронштейне на натяжной потолок',
        price: 600,
        unit: 'PIECE',
      },
      {
        id: 993,
        name: 'Установка кронштейна для люстры в натяжной потолок',
        price: 700,
        unit: 'PIECE',
      },
      {
        id: 988,
        name: 'Обход кондиционера натяжным потолком',
        price: 700,
        unit: 'METER',
      },
      {
        id: 785,
        name: 'Монтаж натяжного потолка',
        price: 600,
        unit: 'METER_SQUARED',
      },
      {
        id: 994,
        name: 'Монтаж точечного светильника на натяжной потолок',
        price: 500,
        unit: 'PIECE',
      },
      {
        id: 990,
        name: 'Монтаж светодиодной ленты на натяжной потолок',
        price: 500,
        unit: 'METER',
      },
      {
        id: 996,
        name: 'Монтаж люстры на крючке на натяжной потолок',
        price: 500,
        unit: 'PIECE',
      },
      {
        id: 995,
        name: 'Отверстие для крючковой люстры в натяжном потолке',
        price: 400,
        unit: 'PIECE',
      },
      {
        id: 992,
        name: 'Обход труб натяжным потолком',
        price: 400,
        unit: 'PIECE',
      },
    ],
    id: 187,
    name: 'Монтаж натяжного потолка',
  },
  301: {
    supplements: [
      {
        id: 1788,
        name: 'Установка душевой кабины с гидромассажем',
        price: 10800,
        unit: 'PIECE',
      },
      {
        id: 1750,
        name: 'Установка встроенного смесителя',
        price: 7700,
        unit: 'PIECE',
      },
      {
        id: 1760,
        name: 'Установка душевого уголка/ширмы с поддоном',
        price: 8400,
        unit: 'PIECE',
      },
      {
        id: 1744,
        name: 'Установка душевой кабины без гидромассажа',
        price: 7800,
        unit: 'PIECE',
      },
      {
        id: 3258,
        name: 'Установка стеклянной ширмы для ванны/поддона с весом более 20 кг',
        price: 7600,
        unit: 'PIECE',
      },
      {
        id: 1786,
        name: 'Установка рамы инсталляции',
        price: 7200,
        unit: 'PIECE',
      },
      {
        id: 1789,
        name: 'Установка ванны с гидромассажем (джакузи)',
        price: 6600,
        unit: 'PIECE',
      },
      {
        id: 1807,
        name: 'Установка чугунной ванны',
        price: 6000,
        unit: 'PIECE',
      },
      {
        id: 1799,
        name: 'Установка стеклянной ширмы для ванны/поддона',
        price: 5100,
        unit: 'PIECE',
      },
      {
        id: 1798,
        name: 'Установка стальной ванны',
        price: 5100,
        unit: 'PIECE',
      },
      {
        id: 1790,
        name: 'Установка раковины с тумбой',
        price: 4800,
        unit: 'PIECE',
      },
      {
        id: 1768,
        name: 'Установка раковины на ножке',
        price: 4200,
        unit: 'PIECE',
      },
      {
        id: 1767,
        name: 'Установка раковины на кронштейнах',
        price: 4200,
        unit: 'PIECE',
      },
      {
        id: 2005,
        name: 'Установка поддона',
        price: 4200,
        unit: 'PIECE',
      },
      {
        id: 1775,
        name: 'Установка пластиковой ширмы для ванны/поддона',
        price: 4200,
        unit: 'PIECE',
      },
      {
        id: 1759,
        name: 'Установка душевой панели',
        price: 4200,
        unit: 'PIECE',
      },
      {
        id: 1777,
        name: 'Установка подвесного унитаза (на готовую инсталляцию)',
        price: 3600,
        unit: 'PIECE',
      },
      {
        id: 1769,
        name: 'Установка напольного унитаза',
        price: 3600,
        unit: 'PIECE',
      },
      {
        id: 1746,
        name: 'Установка биде',
        price: 3600,
        unit: 'PIECE',
      },
      {
        id: 1774,
        name: 'Установка писсуара',
        price: 3400,
        unit: 'PIECE',
      },
      {
        id: 1795,
        name: 'Установка скрытого бачка унитаза',
        price: 2600,
        unit: 'PIECE',
      },
      {
        id: 1797,
        name: 'Установка смесителя (на готовые коммуникации)',
        price: 1800,
        unit: 'PIECE',
      },
      {
        id: 1752,
        name: 'Установка гигиенического душа (на готовые коммуникации)',
        price: 1800,
        unit: 'PIECE',
      },
      {
        id: 77,
        name: 'Установка водяного полотенцесушителя (на готовые коммуникации, на резьбе, без подгонки)',
        price: 1800,
        unit: 'PIECE',
      },
      {
        id: 967,
        name: 'Установка байпаса',
        price: 1800,
        unit: 'PIECE',
      },
      {
        id: 1766,
        name: 'Сборка и установка мебели под раковину',
        price: 1800,
        unit: 'PIECE',
      },
      {
        id: 1771,
        name: 'Отверстие под раковину в столешнице из искусственного камня',
        price: 1500,
        unit: 'PIECE',
      },
      {
        id: 1813,
        name: 'Замена микролифта унитаза',
        price: 1500,
        unit: 'PIECE',
      },
      {
        id: 2507,
        name: 'Вырез отверстия под смеситель в раковине из искусственного камня',
        price: 1500,
        unit: 'PIECE',
      },
      {
        id: 1794,
        name: 'Установка сифона (на готовые коммуникации)',
        price: 900,
        unit: 'PIECE',
      },
      {
        id: 2506,
        name: 'Вырез отверстия под смеситель в керамической раковине/мойке',
        price: 900,
        unit: 'PIECE',
      },
      {
        id: 1751,
        name: 'Установка/замена гибкой подводки',
        price: 800,
        unit: 'PIECE',
      },
      {
        id: 1805,
        name: 'Установка столешницы с вырезом под раковину',
        price: 1500,
        unit: 'PIECE',
      },
      {
        id: 1770,
        name: 'Отверстие под раковину в столешнице из ДСП',
        price: 800,
        unit: 'PIECE',
      },
      {
        id: 1812,
        name: 'Установка экрана под ванну',
        price: 600,
        unit: 'PIECE',
      },
      {
        id: 3379,
        name: 'Установка ниппеля для смесителя',
        price: 400,
        unit: 'PIECE',
      },
      {
        id: 964,
        name: 'Подрезка трубы под размер радиатора',
        price: 500,
        unit: 'PIECE',
      },
    ],
    id: 301,
    name: 'Установка сантехники',
  },
  303: {
    supplements: [
      {
        id: 1772,
        name: 'Сборка и установка пенала для ванной',
        price: 2400,
        unit: 'PIECE',
      },
      {
        id: 1763,
        name: 'Сборка и навеска зеркального шкафа в ванной комнате',
        price: 2400,
        unit: 'PIECE',
      },
      {
        id: 1810,
        name: 'Установка штанги для душа',
        price: 800,
        unit: 'PIECE',
      },
      {
        id: 1762,
        name: 'Навеска зеркала',
        price: 800,
        unit: 'PIECE',
      },
      {
        id: 1776,
        name: 'Монтаж пристенного пластикового уголка',
        price: 500,
        unit: 'PIECE',
      },
      {
        id: 1778,
        name: 'Монтаж подвесного аксессуара',
        price: 500,
        unit: 'PIECE',
      },
    ],
    id: 303,
    name: 'Мебель и аксессуары',
  },
  306: {
    supplements: [
      {
        id: 1808,
        name: 'Демонтаж чугунной ванны',
        price: 2400,
        unit: 'PIECE',
      },
      {
        id: 1757,
        name: 'Демонтаж душевой кабины',
        price: 1800,
        unit: 'PIECE',
      },
      {
        id: 1755,
        name: 'Демонтаж джакузи',
        price: 1800,
        unit: 'PIECE',
      },
      {
        id: 1780,
        name: 'Демонтаж подиума под душевую кабину/ванну',
        price: 1500,
        unit: 'METER_SQUARED',
      },
      {
        id: 1753,
        name: 'Демонтаж гребёнки',
        price: 1500,
        unit: 'PIECE',
      },
      {
        id: 1809,
        name: 'Демонтаж ширмы для ванны',
        price: 1200,
        unit: 'PIECE',
      },
      {
        id: 1804,
        name: 'Демонтаж унитаза',
        price: 1200,
        unit: 'PIECE',
      },
      {
        id: 1764,
        name: 'Демонтаж инсталляции',
        price: 1200,
        unit: 'PIECE',
      },
      {
        id: 1758,
        name: 'Демонтаж душевой панели',
        price: 1200,
        unit: 'PIECE',
      },
      {
        id: 1745,
        name: 'Демонтаж биде',
        price: 1200,
        unit: 'PIECE',
      },
      {
        id: 1742,
        name: 'Демонтаж акриловой/стальной ванны',
        price: 1200,
        unit: 'PIECE',
      },
      {
        id: 2419,
        name: 'Демонтаж акрилового поддона',
        price: 1200,
        unit: 'PIECE',
      },
      {
        id: 1806,
        name: 'Демонтаж фильтра для воды',
        price: 600,
        unit: 'PIECE',
      },
      {
        id: 1783,
        name: 'Демонтаж раковины',
        price: 600,
        unit: 'PIECE',
      },
      {
        id: 1781,
        name: 'Демонтаж полотенцесушителя',
        price: 600,
        unit: 'PIECE',
      },
      {
        id: 1773,
        name: 'Демонтаж писсуара',
        price: 600,
        unit: 'PIECE',
      },
      {
        id: 1765,
        name: 'Демонтаж мебели для ванной',
        price: 600,
        unit: 'PIECE',
      },
      {
        id: 1801,
        name: 'Демонтаж стояка водоснабжения (металлические трубы)',
        price: 500,
        unit: 'PIECE',
      },
      {
        id: 2574,
        name: 'Демонтаж экрана под ванну',
        price: 400,
        unit: 'PIECE',
      },
      {
        id: 1811,
        name: 'Демонтаж штанги для душа',
        price: 400,
        unit: 'PIECE',
      },
      {
        id: 2420,
        name: 'Демонтаж старого герметика',
        price: 400,
        unit: 'METER',
      },
      {
        id: 1796,
        name: 'Демонтаж смесителя',
        price: 400,
        unit: 'PIECE',
      },
      {
        id: 1793,
        name: 'Демонтаж сифона',
        price: 400,
        unit: 'PIECE',
      },
      {
        id: 1791,
        name: 'Демонтаж сети отопления и водоснабжения',
        price: 250,
        unit: 'METER',
      },
      {
        id: 1800,
        name: 'Демонтаж стояка водоснабжения (полипропилен)',
        price: 200,
        unit: 'PIECE',
      },
      {
        id: 1743,
        name: 'Демонтаж бачка напольного унитаза',
        price: 300,
        unit: 'PIECE',
      },
      {
        id: 1803,
        name: 'Демонтаж труб водоснабжения',
        price: 200,
        unit: 'METER',
      },
    ],
    id: 306,
    name: 'Демонтаж сантехники',
  },
  511: {
    supplements: [
      {
        id: 4407,
        name: 'Оштукатуривание декоративной штукатуркой ручного нанесения внутри помещения',
        price: 1200,
        unit: 'METER_SQUARED',
      },
      {
        id: 769,
        name: 'Выравнивание потолка',
        price: 1000,
        unit: 'METER_SQUARED',
      },
      {
        id: 3376,
        name: 'Выравнивание откосов, ниш, коробов без отделки стен/потолков',
        price: 800,
        unit: 'METER',
      },
      {
        id: 4373,
        name: 'Оштукатуривание откосов',
        price: 900,
        unit: 'METER',
      },
      {
        id: 192,
        name: 'Шпатлёвка потолка под покраску',
        price: 650,
        unit: 'METER_SQUARED',
      },
      {
        id: 191,
        name: 'Шпатлёвка стен под покраску',
        price: 600,
        unit: 'METER_SQUARED',
      },
      {
        id: 1262,
        name: 'Устройство отверстия для подрозетника в бетоне',
        price: 800,
        unit: 'PIECE',
      },
      {
        id: 1301,
        name: 'Сверление отверстия в бетоне под розетку/выключатель/монтажную коробку',
        price: 800,
        unit: 'PIECE',
      },
      {
        id: 1995,
        name: 'Оштукатуривание стен с выравниванием по маякам (до 30 мм)',
        price: 800,
        unit: 'METER_SQUARED',
      },
      {
        id: 825,
        name: 'Выравнивание стены',
        price: 800,
        unit: 'METER_SQUARED',
      },
      {
        id: 765,
        name: 'Штукатурка потолка',
        price: 700,
        unit: 'METER_SQUARED',
      },
      {
        id: 190,
        name: 'Шпатлёвка потолка под обои (1 слой)',
        price: 700,
        unit: 'METER_SQUARED',
      },
      {
        id: 1283,
        name: 'Шумоизоляция потолка с помощью ЗИППС-плит',
        price: 600,
        unit: 'METER_SQUARED',
      },
      {
        id: 189,
        name: 'Шпатлёвка стен под обои (1 слой)',
        price: 600,
        unit: 'METER_SQUARED',
      },
      {
        id: 1260,
        name: 'Устройство отверстия для подрозетника в гипсокартоне',
        price: 600,
        unit: 'PIECE',
      },
      {
        id: 636,
        name: 'Сквозное отверстие в стене',
        price: 600,
        unit: 'PIECE',
      },
      {
        id: 1303,
        name: 'Сверление отверстия в кирпиче под розетку/выключатель/монтажную коробку',
        price: 500,
        unit: 'PIECE',
      },
      {
        id: 187,
        name: 'Оштукатуривание стен под правило (до 30 мм)',
        price: 600,
        unit: 'METER_SQUARED',
      },
      {
        id: 3714,
        name: 'Шпатлёвка гипсокартона до 3 м. высоты',
        price: 500,
        unit: 'METER_SQUARED',
      },
      {
        id: 1261,
        name: 'Устройство отверстия для подрозетника в кирпиче',
        price: 500,
        unit: 'PIECE',
      },
      {
        id: 1302,
        name: 'Сверление отверстия в ГКЛ под розетку/выключатель/монтажную коробку',
        price: 500,
        unit: 'PIECE',
      },
      {
        id: 757,
        name: 'Визуальное выравнивание потолка гипсовыми составами',
        price: 500,
        unit: 'METER_SQUARED',
      },
      {
        id: 638,
        name: 'Штробление в кирпиче',
        price: 400,
        unit: 'METER',
      },
      {
        id: 1305,
        name: 'Штробление в газобетоне',
        price: 300,
        unit: 'METER',
      },
      {
        id: 1097,
        name: 'Удаление плесени, протечек, пятен',
        price: 300,
        unit: 'METER_SQUARED',
      },
      {
        id: 193,
        name: 'Смывка побелки',
        price: 300,
        unit: 'METER_SQUARED',
      },
      {
        id: 826,
        name: 'Звуко и теплоизоляция стен',
        price: 400,
        unit: 'METER_SQUARED',
      },
      {
        id: 824,
        name: 'Визуальное выравнивание стен гипсовыми составами',
        price: 400,
        unit: 'METER_SQUARED',
      },
      {
        id: 628,
        name: 'Штробление в гипсокартоне',
        price: 300,
        unit: 'METER',
      },
      {
        id: 1098,
        name: 'Удаление эмали',
        price: 250,
        unit: 'METER_SQUARED',
      },
      {
        id: 1102,
        name: 'Удаление старого лакокрасочного материала',
        price: 300,
        unit: 'METER_SQUARED',
      },
      {
        id: 195,
        name: 'Удаление масляной краски со стен или с потолка',
        price: 300,
        unit: 'METER_SQUARED',
      },
      {
        id: 1330,
        name: 'Демонтаж декоративной штукатурки',
        price: 250,
        unit: 'METER_SQUARED',
      },
      {
        id: 763,
        name: 'Изоляция потолка (тепло / шумо / гидро)',
        price: 300,
        unit: 'METER_SQUARED',
      },
      {
        id: 198,
        name: 'Демонтаж штукатурки до основания стены или плиты перекрытия',
        price: 300,
        unit: 'METER_SQUARED',
      },
      {
        id: 818,
        name: 'Гидроизоляционная штукатурка стены',
        price: 300,
        unit: 'METER_SQUARED',
      },
      {
        id: 196,
        name: 'Удаление водоэмульсионной краски со стен или с потолка',
        price: 180,
        unit: 'METER_SQUARED',
      },
      {
        id: 771,
        name: 'Шлифовка потолка',
        price: 200,
        unit: 'METER_SQUARED',
      },
      {
        id: 817,
        name: 'Установка малярных уголков',
        price: 150,
        unit: 'METER',
      },
      {
        id: 764,
        name: 'Обработка потолка защитными составами',
        price: 200,
        unit: 'METER_SQUARED',
      },
      {
        id: 759,
        name: 'Заделка мелких трещин, сколов на потолке',
        price: 200,
        unit: 'METER_SQUARED',
      },
      {
        id: 1081,
        name: 'Дополнительный слой шпатлёвки',
        price: 150,
        unit: 'METER_SQUARED',
      },
      {
        id: 823,
        name: 'Гидроизоляция и пароизоляция стен',
        price: 200,
        unit: 'METER_SQUARED',
      },
      {
        id: 770,
        name: 'Армирование потолка (малярная сетка, паутинка)',
        price: 200,
        unit: 'METER_SQUARED',
      },
      {
        id: 828,
        name: 'Шлифовка стен',
        price: 200,
        unit: 'METER_SQUARED',
      },
      {
        id: 1304,
        name: 'Устройство отверстий в ГКЛ под кабель электроснабжения диаметром не более 10 мм',
        price: 100,
        unit: 'PIECE',
      },
      {
        id: 766,
        name: 'Снятие обоев и клея',
        price: 200,
        unit: 'METER_SQUARED',
      },
      {
        id: 625,
        name: 'Заделка штробы',
        price: 200,
        unit: 'METER',
      },
      {
        id: 821,
        name: 'Заделка мелких трещин, сколов на стене',
        price: 200,
        unit: 'METER_SQUARED',
      },
      {
        id: 760,
        name: 'Грунтовка потолка',
        price: 200,
        unit: 'METER_SQUARED',
      },
      {
        id: 820,
        name: 'Армирование стен (малярная сетка, паутинка)',
        price: 200,
        unit: 'METER_SQUARED',
      },
      {
        id: 1299,
        name: 'Удаление маяков',
        price: 70,
        unit: 'METER',
      },
      {
        id: 822,
        name: 'Грунтовка стен',
        price: 100,
        unit: 'METER_SQUARED',
      },
    ],
    id: 511,
    name: 'Подготовительные работы',
  },
};
